import { render, staticRenderFns } from "./DiseaseDeleteModal.vue?vue&type=template&id=ac81ea42&scoped=true"
import script from "./DiseaseDeleteModal.vue?vue&type=script&lang=js"
export * from "./DiseaseDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac81ea42",
  null
  
)

export default component.exports